import React,{createContext ,useState , useRef ,useEffect } from 'react';
import {io} from 'socket.io-client';
import Peer from 'simple-peer';

const SocketContext = createContext();

const socket = io('https://peer-to--peer.herokuapp.com/');

const ContextProvider = ({children}) =>{
    const [stream, setstream] = useState(null);
    const [me, setme] = useState('');
    const [call, setcall] = useState({});
    const [callAccepted, setcallAccepted] = useState(false);
    const [callEnded, setcallEnded] = useState(false);
    const [name, setname] = useState('');


    const myVideo = useRef();
    const userVideo = useRef();
    const connectionRef = useRef();

    useEffect(()=>{
        navigator.mediaDevices.getUserMedia({video:true  , audio:true })
        .then((currentStream) =>{
            setstream(currentStream);

            myVideo.current.srcObject = currentStream;
        } );
        socket.on('me',(id) => setme(id)); 

        socket.on('callUser',( {from , name : callerName ,signal})=>{
                setcall({isReceivedCall : true , from,name:callerName,signal})
        });
    }, []);
    
    const answerCall = ()=>{
            setcallAccepted(true)
            const peer = new Peer({initiator:false , trickle:false ,stream});
            peer.on('signal',(data)=>{
                    socket.emit('answerCall',{signal:data,to:call.from});
            });
            peer.on('stream',(currentStream)=>{
                userVideo.current.srcObject = currentStream;
            });
            peer.signal(call.signal);

            connectionRef.current = peer;
    } 

    const callUser = (id)=>{
        const peer = new Peer({initiator:true , trickle:false ,stream});
        peer.on('signal',(data)=>{
            socket.emit('callUser',{userToCall:id , signalData:data ,from: me,name});
        });
        peer.on('stream',(currentStream)=>{
            userVideo.current.srcObject = currentStream;
        });

        socket.on('callAccepted',(signal)=>{
            setcallAccepted(true);
            peer.signal(signal);
        });
        connectionRef.current = peer;
    } 
    const leaveCall = ()=>{
            setcallEnded(true);
            connectionRef.current.destroy();

            window.location.reload();
    } 
    
    return (
        <SocketContext.Provider value={{
            call,
            callAccepted,
            myVideo,
            userVideo,
            stream,
            name,
            setname,
            callEnded,
            me,
            callUser,
            leaveCall,
            answerCall,
        }}>
            {children}
        </SocketContext.Provider>
    )
}
export {ContextProvider ,SocketContext};

